export default __webpack_public_path__ + "static/media/hht1_direction_eggstudio_02.30fcb76b.png";